// combatpro/panels/spells/SpellToolbar.js
//
// Combat PRO - SpellToolbar (functional migration of the spell system).
//
// Reproduces the spells-section header row (vi-section-hdr-row) from the
// spells-block template in battletracker.html: the "Active Spells" section
// title plus the Random Spell and Add Spell buttons. The original onclick
// attributes are converted into received handler props and forwarded only; the
// handlers themselves are NOT implemented here.
//   - selectRandomSpell(index, 0) -> onRandomSpell(index, 0)
//   - vi_openAddSpellModal()      -> onAddSpell
//
// NOTE (source fidelity): in the master spec the Random Spell button has a
// duplicate class attribute (class="btn-primary-gold" class="vi-btn vi-btn-sm").
// HTML keeps the first attribute and ignores the second, so the browser-rendered
// className is "btn-primary-gold"; that is reproduced here. The Add Spell
// button's id (addCustomSpellBtn) is static in the source (not interpolated per
// index) and is preserved as-is.
//
// Imports only React. No state, hooks, business logic, or handler
// implementations. Do not edit battletracker.html.

import React from 'react';

function SpellToolbar(props) {
  const index = props.index;
  return (
    <div className="vi-section-hdr-row">
      <div className="section-title">Active Spells</div>
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <button onClick={() => props.onRandomSpell(index, 0)} className="btn-primary-gold">🎲 Random Spell</button>
        <button onClick={props.onAddSpell} className="vi-add-spell-btn" id="addCustomSpellBtn" data-tooltip="Create a custom spell. Define damage, effects, saves, and behaviour. Saved to your account and available across all sessions.">✨ Add Spell</button>
      </div>
    </div>
  );
}

export default SpellToolbar;
